// Web Banners
import ICaisnoBanner1 from '../assets/images/banners/casino/icasino_banner1.png';
import Banner1 from '../assets/images/banners/casino/banner1.png';
import Banner2 from '../assets/images/banners/casino/banner2.png';
import cricket from '../assets/images/banners/casino/cricketBanner.png';

// Mobile banners
import MobCaisnoBanner1 from '../assets/images/banners/casino/mobile_banner1.png';
import MobCaisnoBanner2 from '../assets/images/banners/casino/mobile_banner2.png';
import MobICaisnoBanner1 from '../assets/images/banners/casino/icasino_mob_banner1.png';
import cricketMob from '../assets/images/banners/casino/mobBanner.png';

const CASINO_WEB_BANNERS = [
  {
    image: cricket,
    text: 'Cricket',
  },
  // {
  //   image: Banner2,
  //   text: 'Casino',
  // },
];

const IND_CASINO_WEB_BANNERS = [
  {
    image:
      'https://cdn.hypex.one/hypex/indian_casino_web2.png',
    text: 'Indian Casino',
  },
  {
    image:
      'https://cdn.hypex.one/hypex/indian_casino_web.png',
    text: 'Indian Casino',
  },
];

const CASINO_MOBILE_BANNERS = [
  {
    image: cricketMob,
    text: ' Cricket',
  },
  // {
  //   image: MobCaisnoBanner2,
  //   text: 'Live Casino',
  // },
];

const IND_CASINO_MOBILE_BANNERS = [
  {
    image:
      'https://cdn.hypex.one/hypex/indian_casino_mob.png',
    text: 'Indian Casino',
  },
];

export default {
  CASINO_WEB_BANNERS,
  CASINO_MOBILE_BANNERS,
  IND_CASINO_WEB_BANNERS,
  IND_CASINO_MOBILE_BANNERS,
};
